import { ItemsI } from '../types';

/**
 * GetNextContainerId.
 */
export const getNextContainerId = (items: ItemsI) => {
  const containerIds = Object.keys(items);
  const lastContainerId = containerIds[containerIds.length - 1];

  return String.fromCharCode(lastContainerId.charCodeAt(0) + 1);
};
